import React from 'react';
import { useObserver } from 'mobx-react-lite';

import useProduct from 'hooks/use-product';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { imageToUse } from 'shared/helpers/products';
import { useCommerceComponents } from 'src/theme/provider/commerce-components/context';
import JsonLDScript from './json-ld/json-id-script';

import { hasThemeOgImage } from './has-theme-og-image';
import Meta from './meta';

export default function ProductTags() {
  const { product } = useProduct();
  const { dispensary } = useDispensary();
  const { metaFields } = useCommerceComponents();
  const image = useObserver(() => (product ? imageToUse(product) : null));
  const themeSuppliesOgImage = hasThemeOgImage(metaFields);

  if (!product) {
    return null;
  }

  return (
    <>
      {!themeSuppliesOgImage && <Meta property='og:image' content={image} />}
      <JsonLDScript variant='product' jsonLdData={{ ...product, location: dispensary?.location, seller: dispensary }} />
    </>
  );
}
